module.exports = __webpack_public_path__ + "img/fashion_32.c448ed15.jpg";